<template>
	<modal ref="modal">
		<template #title>Welcome Call</template>
		<template #body>
			<div class="mb-4">
				<label
					for="mobile_no"
					class="form-label"
					:class="{ 'text-danger': form.errors.mobile_no }"
				>
					Mobile number
				</label>
				<vue-tel-input
					@input="onInput"
					@countryChanged="onCountryChange"
					id="mobile_no"
					v-model="form.mobile_no"
					:value="form.mobile_no"
					class="form-control"
					:class="{ 'is-invalid': form.errors.mobile_no }"
					:input-options="{
						placeholder: 'Enter mobile number',
					}"
					:defaultCountry="member.country_code"
					mode="international"
				/>
				<div v-if="form.errors.mobile_no" class="invalid-feedback">
					{{ form.errors.mobile_no }}
				</div>
			</div>
			<div class="form-floating mb-4">
				<select
					v-model="form.location"
					id="location"
					class="form-select"
					placeholder="Select location"
				>
					<option value="Philippines">Philippines</option>
					<option value="Foreign">Foreign</option>
				</select>
				<label class="form-label" for="location">Location</label>
			</div>
			<div class="form-floating mb-4">
				<select
					v-model="form.status"
					id="status"
					class="form-select"
					placeholder="Select status"
				>
					<option value="Completed">Completed</option>
					<option value="For Callback">For Callback</option>
					<option value="No Answer">No Answer</option>
				</select>
				<label class="form-label" for="status">Status</label>
			</div>
			<div class="form-floating mb-4">
				<flat-pickr
					v-model="form.called_at"
					id="call-date"
					class="form-control"
					placeholder="Enter call date"
					:config="{
						enableTime: true,
						altInput: true,
						altFormat: 'M j, Y h:i K',
						dateFormat: 'Y-m-d H:i:s',
						wrap: true,
					}"
					:class="
						form.errors.called_at
							? 'flatpickr-input is-invalid border-danger'
							: 'flatpickr-input'
					"
				/>
				<label
					class="form-label"
					for="call-date"
					:class="{ 'text-danger': form.errors.called_at }"
				>
					Call Date & Time
				</label>
				<div v-if="form.errors.called_at" class="invalid-feedback">
					{{ form.errors.called_at }}
				</div>
			</div>
			<div class="form-floating mb-4">
				<textarea
					v-model="form.remarks"
					id="remarks"
					class="form-control"
					placeholder="Enter remarks"
					style="height: 150px"
					:class="{ 'is-invalid': form.errors.remarks }"
				></textarea>
				<label
					class="form-label"
					for="remarks"
					:class="{ 'text-danger': form.errors.remarks }"
				>
					Remarks
				</label>
				<div v-if="form.errors.remarks" class="invalid-feedback">
					{{ form.errors.remarks }}
				</div>
			</div>
		</template>
		<template #footer>
			<button
				@click="addWelcomeCall"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				Submit
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		member: Object,
		admin: Object,
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const onInput = (number, phoneObject) => {
			if (phoneObject?.formatted) {
				form.mobile_no = number
			}
		}

		const onCountryChange = (countryObject) => {
			form.country_code = countryObject.iso2
		}

		const form = useForm({
			member_id: props.member.counter,
			calledby: props.admin.full_name,
			location: 'Philippines',
			status: 'Completed',
			mobile_no: props.member.mobile,
			country_code: props.member.country_code,
			remarks: null,
			called_at: new Date(),
		})

		const addWelcomeCall = () => {
			form
				.transform((data) => ({
					...data,
					mobile_no: data.mobile_no.replace(/\s+/g, ''),
				}))
				.post(route('admin.post.add-welcome-call'), {
					preserveState: true,
					preserveScroll: true,
					onSuccess: () => {
						form.reset()
						toggleModal()
					},
				})
		}

		return {
			form,
			modal,
			onInput,
			toggleModal,
			addWelcomeCall,
			onCountryChange,
		}
	},
}
</script>
